import React, { useContext } from 'react';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { useHistory } from 'react-router-dom';
import BatchForm from '../../BatchForm';
import Page from '../../Page';
import BatchesContext from '../BatchesContext';
import translations from './translations';

const CreateBatch = () => {
  const intl = useIntl();
  const history = useHistory();
  const { actionsCode, excludeActions } = useContext(BatchesContext);

  return (
    <Page title={intl.formatMessage(translations.title)} fullWidth>
      <BatchForm
        actionsCode={actionsCode}
        excludeActions={excludeActions}
        onCancel={() => history.push('/batches')}
        onFinish={() => history.push('/batches')}
      />
    </Page>
  );
};

export default CreateBatch;
